import React from 'react';
import { Link } from 'react-router-dom';

function NatConResources() {
  return (
    <div>
      <h1>National Convention: Resources and Guidance</h1>
      <br />
      <h3>The 118th Bahá’í National Convention will be held April 23-26, 2026</h3>
      <hr />
      <h3>Compilations from the Bahá’í World Center</h3>
      <p>
        <a href="https://bahai-web.s3.amazonaws.com/NatCon/2022/UHJ-Compilation-on-National-Convention-Dec92.pdf">
          “The National Convention” - A compilation from the Research Dept. (UHJ, 1992) (PDF)
        </a>
      </p>
      <p>
        <a href="https://bahai-web.s3.amazonaws.com/NatCon/2022/UHJ-Statement-on-National-Convention-Dec92.pdf">
          “The National Convention” - A statement from the Research Dept. (UHJ, 1992) (PDF)
        </a>
      </p>
      <p>
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/NatCon/2025/Compilation+%E2%80%93+The+National+Spiritual+Assembly+%E2%80%93+October+2023+(English).pdf">
          Compilation on the National Spiritual Assembly (2023) (PDF)
        </a>
      </p>
      <h3>Letters from the Universal House of Justice</h3>
      <p>
        <a href="https://s3.amazonaws.com/bahai-web/tab/forms/March-25-2007-Electoral-Procedure.pdf">
          March 25, 2007 Letter from UHJ on the Bahá’í electoral process (PDF)
        </a>
      </p>
      <p>
        <a href="https://s3.amazonaws.com/bahai-web/tab/forms/May-16-2013-UHJ-to-delegates.pdf">
          May 16, 2013 Letter from UHJ on the sacred nature of National Convention (PDF)
        </a>
      </p>
      <p>
        <a href="https://bahai-web.s3.amazonaws.com/NatCon/2022/20160804-UHJ-to-all-NSAs-on-the-Allocation-of-Delegates.pdf">
          August 4, 2016 Letter from UHJ on the allocation of delegates (PDF)
        </a>
      </p>
      <p>
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/NatCon/2025/20231128+Reflections+on+the+First+Century+of+the+Formative+Age+(English).pdf">
          November 28, 2023 Supreme Body Shares Historical Review and Reflections on the Future (PDF)
        </a>
      </p>
      <h3>NSA By-Laws Relating to National Conventions</h3>
      <p>
        <a href="https://bahai-web.s3.amazonaws.com/NatCon/2023/Complete+Article+VIII+of+Constitution+and+By-Laws+of+US+NSA.pdf">
          Article VIII of the Constitution and By-Laws of the US NSA (PDF)
        </a>
      </p>
      <h3>
        <em>The American Bahá’í</em> Coverage
      </h3>
      <p>
        <Link to="/news">
          National Convention Coverage from <em>The American Bahá’í</em>
        </Link>
      </p>
    </div>
  );
}

export default NatConResources;
